import { HttpServiceResponse } from '../../shared'
import { LinkedFilesActions } from '../models/linkedFiles.types'
import { LinkedFilesParams } from '../models'
import AbstractAccountProvider from './linkedFiles-abstract.provider'

export class FilesActionProvider extends AbstractAccountProvider {
  urlPath = 'linkedfiles_api'

  public fileAction<T>(action: LinkedFilesActions, params: LinkedFilesParams): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      action,
    })

    return this.http.post(`${this.url}?${query}`, params)
  }
}
